import { msg } from "@lingui/core/macro";

export const formValidationMessages = {
	required: msg`This field is required`,
	tooSmall: msg`This value is too small`,
	tooBig: msg`This value is too big`,
	invalidFormat: msg`This value is not valid`,
	errors: {
		schedule: {
			overlap: msg`Schedule time ranges must not overlap`,
			no_days_selected: msg`Select at least one day for the recurring schedule`,
		},
		interval: {
			overlap_option_ranges: msg`This entry overlaps an existing range. Create a separate Option instead.`,
		},
		before_date: {
			inclusive: msg({ message: "Date must be on or after {date}" }),
			not_inclusive: msg({ message: "Date must be after {date}" }),
		},
		before_time: {
			inclusive: msg({ message: "Time must be at or after {date}" }),
			not_inclusive: msg({ message: "Time must be after {date}" }),
		},
		before_datetime: {
			inclusive: msg({ message: "Date must be on or after {datetime}" }),
			not_inclusive: msg({ message: "Date must be after {datetime}" }),
		},
		after_date: {
			inclusive: msg({ message: "Date must be on or before {date}" }),
			not_inclusive: msg({ message: "Date must be before {date}" }),
		},
		after_time: {
			inclusive: msg({ message: "Time must be at or before {date}" }),
			not_inclusive: msg({ message: "Time must be before {date}" }),
		},
		after_datetime: {
			inclusive: msg({ message: "Date must be on or before {datetime}" }),
			not_inclusive: msg({ message: "Date must be before {datetime}" }),
		},
		duration_max: {
			inclusive: msg({ message: "Duration must be less than or equal to {max}" }),
			not_inclusive: msg({ message: "Duration must be less than {max}" }),
		},
		duration_min: {
			inclusive: msg({ message: "Duration must be greater than or equal to {min}" }),
			not_inclusive: msg({ message: "Duration must be greater than {min}" }),
		},
		duration_days: {
			mismatch: msg({ message: "Expiry date must be {days} day(s) from start date" }),
		},
		invalid_day_of_week: msg({ message: "Date must fall on {allowedDays}" }),
		invalid_timezone: msg`Invalid Timezone`,
		invalid_type: msg({ message: "{field} must be {expected}" }),
		invalid_type_received_undefined: msg({ message: "{field} is required" }),
		invalid_type_received_null: msg({ message: "{field} is required" }),
		unrecognized_keys_one: msg({ message: "Unrecognized key in object: {keys}" }),
		unrecognized_keys_other: msg({ message: "Unrecognized keys in object: {keys}" }),
		invalid_union: msg({ message: "{field} is invalid" }),
		custom: msg({ message: "{field} is invalid" }),
		not_multiple_of: msg({ message: "{field} must be a multiple of {divisor}" }),
		invalid_value_one: msg({ message: "{field} must be {values}" }),
		invalid_value_other: msg({ message: "{field} must be one of: {values}" }),
		invalid_key_one: msg({ message: "Invalid key in object: {keys}" }),
		invalid_key_other: msg({ message: "Invalid keys in object: {keys}" }),
		invalid_element: msg({ message: "Invalid {origin}" }),
		invalid_string: {
			number: msg`Must be a number`,
		},
		too_small: {
			array: {
				exact: msg({ message: "{field} must contain exactly {minimum} element(s)" }),
				inclusive: msg({ message: "{field} must contain at least {minimum} element(s)" }),
				inclusive_one: msg({ message: "{field} is required" }),
				not_inclusive: msg({ message: "{field} must contain more than {minimum} element(s)" }),
			},
			string: {
				exact: msg({ message: "{field} must contain exactly {minimum} character(s)" }),
				inclusive: msg({ message: "{field} must contain at least {minimum} character(s)" }),
				inclusive_one: msg({ message: "{field} is required" }),
				not_inclusive: msg({ message: "{field} must contain over {minimum} character(s)" }),
			},
			number: {
				exact: msg({ message: "{field} must be exactly {minimum}" }),
				inclusive: msg({ message: "{field} must be greater than or equal to {minimum}" }),
				not_inclusive: msg({ message: "{field} must be greater than {minimum}" }),
			},
			set: {
				exact: msg({ message: "{field} is invalid" }),
				inclusive: msg({ message: "{field} is invalid" }),
				not_inclusive: msg({ message: "{field} is invalid" }),
			},
			date: {
				exact: msg({ message: "{field} must be exactly {minimum}" }),
				inclusive: msg({ message: "{field} must be on or after {minimum}" }),
				not_inclusive: msg({ message: "{field} must be after {minimum}" }),
			},
		},
		too_big: {
			array: {
				exact: msg({ message: "{field} must contain exactly {maximum} element(s)" }),
				exact_with_path: msg({ message: "Exactly {maximum} {path}(s) required" }),
				inclusive: msg({ message: "{field} must contain at most {maximum} element(s)" }),
				inclusive_with_path: msg({ message: "Maximum {maximum} {path}(s) allowed" }),
				not_inclusive: msg({ message: "{field} must contain less than {maximum} element(s)" }),
				not_inclusive_with_path: msg({ message: "Less than {maximum} {path}(s) allowed" }),
			},
			string: {
				exact: msg({ message: "{field} must contain exactly {maximum} character(s)" }),
				inclusive: msg({ message: "{field} must contain at most {maximum} character(s)" }),
				not_inclusive: msg({ message: "{field} must contain under {maximum} character(s)" }),
			},
			number: {
				exact: msg({ message: "{field} must be exactly {maximum}" }),
				inclusive: msg({ message: "{field} must be less than or equal to {maximum}" }),
				not_inclusive: msg({ message: "{field} must be less than {maximum}" }),
			},
			set: {
				exact: msg({ message: "{field} is invalid" }),
				inclusive: msg({ message: "{field} is invalid" }),
				not_inclusive: msg({ message: "{field} is invalid" }),
			},
			date: {
				exact: msg({ message: "{field} must be exactly {maximum}" }),
				inclusive: msg({ message: "{field} must be on or before {maximum}" }),
				not_inclusive: msg({ message: "{field} must be before {maximum}" }),
			},
		},
		invalid_format: {
			email: msg({ message: "{field} must be a valid email address" }),
			url: msg({ message: "{field} must be a valid URL" }),
			uuid: msg({ message: "{field} must be a valid UUID" }),
			cuid: msg({ message: "{field} must be a valid CUID" }),
			datetime: msg({ message: "{field} must be a valid datetime" }),
			startsWith: msg({ message: '{field} must start with "{startsWith}"' }),
			endsWith: msg({ message: '{field} must end with "{endsWith}"' }),
			includes: msg({ message: '{field} must include "{includes}"' }),
			regex: msg({ message: "{field} has an invalid format" }),
			generic: msg({ message: "{field} has an invalid {format}" }),
		},
		permit_not_found: msg`We couldn't find a permit or registration using that confirmation number`,
		default_field_name: msg({ message: 'Cannot add "{Notes}" - this field already exists by default' }),
		duplicate_name: msg`This field label already exists. Please use a unique label`,
		duplicate_permission: msg`Duplicate permission for the same entity`,
		email_already_exists: msg`Email already exists`,
		identifier_already_exists: msg`Identifier already exists`,
		invalid_phone_number: msg`Invalid Phone Number`,
		location_number_prefix_already_exists: msg`Location number prefix already exists`,
		location_name_already_exists: msg`Location name already exists`,
		name_already_exists: msg`Name already exists`,
		numbers_only: msg`Only numbers allowed`,
		whole_numbers_only: msg`Only whole numbers allowed`,
		parking_lot_already_exists: msg`Parking Lot Name already exists`,
		venue_already_exists: msg`Venue Name already exists`,
		selected_files_size_too_large: msg({
			message: "Selected files are too large. Maximum total file size is {maxSize}",
		}),
		one_integration_type_per_company: msg`Only one integration type per company is allowed`,
		one_internal_name_per_type_per_company: msg`Integration with this name already exists on this company`,
		payment_connection: msg`There was an issue connecting to your payment provider. Please try again or contact support.`,
		vehicle_already_exists: msg`Please enter unique vehicles.`,
		customer_email_already_exists: msg`A customer with this email already exists`,
		customer_external_id_already_exists: msg`A customer with this external ID already exists`,
		contact_duplicate_exists: msg`A contact with these exact details already exists.`,
		vehicle: {
			plate_required: msg`License plate is required`,
			plate_invalid: msg`Please enter a valid license plate (up to 10 characters)`,
		},
		vehicle_limits: {
			plates_exceeded_one: msg({ message: "Plate limit exceeded. Please remove {count} plate" }),
			plates_exceeded_other: msg({ message: "Plate limit exceeded. Please remove {count} plates" }),
		},
		permit_type_location_not_associated_with_tenant: msg`One or more selected locations aren't associated with this permit type's tenant(s). Associate them with the tenant first, or remove them before saving.`,
		permit_type_dashboard_disabled: msg`Permits cannot be created from the dashboard for this permit type`,
		all_but_last_interval_require_expiry: msg`All but last interval must have an expiry date`,
		expiry_required: msg`Expiry date and time are required`,
		save_instructions_when_empty: msg`Cannot save instructions when empty`,
		save_attachments_without_attachments: msg`Cannot save attachments without attachments`,
		either_instructions_or_attachments: msg`Either instructions or attachments are required`,
		location_required_for_lookup_link: msg`Location is required for portal link`,
		reference_code_without_value: msg`Reference code value is required when code label is provided`,
		duration_set_required: msg`At least one value (weeks, days, hours, or minutes) is required`,
		key_name_required_with_value: msg`Key name is required when key value is provided`,
		key_value_required_with_name: msg`Key value is required when key name is provided`,
		at_least_one_location_required: msg`At least one location must be selected`,
		multiple_never_expires: msg`Only one interval can be set to never expire.`,
		overlaps_with_never_expires: msg`This interval overlaps with one that never expires.`,
		never_expires_must_be_last: msg`An interval that never expires must be the last interval.`,
	},
	validations: {
		email: msg`email`,
		url: msg`URL`,
		uuid: msg`UUID`,
		cuid: msg`CUID`,
		regex: msg`format`,
		datetime: msg`datetime`,
	},
	// Slotted into "{field} must be {expected}" in a form-validation error an end user reads.
	// Nothing in the product matches these back to a schema, so readability wins over literalness:
	// the article-carrying descriptors are ordinary nouns and get translated, while the bare tokens
	// are literals with no natural-language equivalent and stay verbatim.
	types: {
		function: msg({
			message: "a function",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		number: msg({
			message: "a number",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		string: msg({
			message: "a string",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		nan: msg({
			message: "not a number",
			comment:
				"Completes the form error “{field} must be …”; a plain-language phrase, not a type token — translate normally",
		}),
		integer: msg({
			message: "an integer",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		float: msg({
			message: "a number",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		boolean: msg({
			message: "a boolean",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		date: msg({
			message: "a date",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		bigint: msg({
			message: "a bigint",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		undefined: msg({
			message: "undefined",
			comment:
				"Completes the form error “{field} must be …”; a literal token with no natural-language equivalent — keep verbatim in every locale",
		}),
		symbol: msg({
			message: "a symbol",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		null: msg({
			message: "null",
			comment:
				"Completes the form error “{field} must be …”; a literal token with no natural-language equivalent — keep verbatim in every locale",
		}),
		array: msg({
			message: "an array",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		object: msg({
			message: "an object",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		unknown: msg({
			message: "unknown",
			comment:
				"Completes the form error “{field} must be …”; a literal token with no natural-language equivalent — keep verbatim in every locale",
		}),
		promise: msg({
			message: "a promise",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		void: msg({
			message: "void",
			comment:
				"Completes the form error “{field} must be …”; a literal token with no natural-language equivalent — keep verbatim in every locale",
		}),
		never: msg({
			message: "never",
			comment:
				"Completes the form error “{field} must be …”; a literal token with no natural-language equivalent — keep verbatim in every locale",
		}),
		map: msg({
			message: "a map",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		set: msg({
			message: "a set",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		tuple: msg({
			message: "a tuple",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
		record: msg({
			message: "a record",
			comment:
				"Completes the form error “{field} must be …”; the noun for a key-value object (Record<K, V>), not a database row or a sporting record — translate normally, article included",
		}),
		file: msg({
			message: "a file",
			comment:
				"Completes the form error “{field} must be …”; an ordinary noun for the value's shape — translate normally, article included",
		}),
	},
} as const;
